import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import AdminHeader from "@components/AdminHeader";
import CompanyPage from "@pages/Company";
import GroupPage from "@pages/Group";
import GroupsPage from "@pages/Groups";
import InboxPage from "@pages/Inbox";
import MessagePage from "@pages/Message";
import MessageSentPage from "@pages/MessageSent";
import ReceivedMessagePage from "@pages/ReceivedMessage";
import SchedulesPage from "@pages/Schedules";
import SmsMoDrPage from "@pages/SmsMoDr";
import UsersPage from "@pages/Users";
import OutboxPage from "@pages/Outbox";

const useStyles = makeStyles(() => ({
  admin: {
    position: "absolute",
    top: "0px",
    left: "0px",
    width: "100%",
    minHeight: "100%",
    maxHeight: "100%",
    paddingTop: "64px",
    backgroundColor: "#f8f8f8",
    boxSizing: "border-box",
    overflow: "auto",
    "@media all and (min-width: 1024px)": {
      paddingLeft: "260px",
    },
  },
  adminContent: {
    margin: "16px",
    boxSizing: "border-box",
    "@media all and (min-width: 1024px)": {
      margin: "30px",
    },
  },
}));

function Admin() {
  const classes = useStyles();
  const userGroup = useSelector((state) => state.auth.group);

  return (
    <div className={classes.admin}>
      <AdminHeader />
      <div className={classes.adminContent}>
        <Switch>
          <Route exact path="/">
            <Redirect to="/mensagem" />
          </Route>

          <Route path="/empresa">
            <CompanyPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Empresa",
                  path: "/empresa",
                },
              ]}
            />
          </Route>

          <Route path="/mensagem">
            <MessagePage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Mensagem",
                  path: "/mensagem",
                },
              ]}
            />
          </Route>
          <Route path="/agendamentos">
            <SchedulesPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Agendamentos",
                  path: "",
                },
              ]}
            />
          </Route>
          <Route path={["/grupos/novo", "/grupos/:id"]}>
            <GroupPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Grupos",
                  path: "/grupos",
                },
                {
                  label: "",
                  path: "",
                },
              ]}
            />
          </Route>
          <Route path="/grupos">
            <GroupsPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Grupos",
                  path: "",
                },
              ]}
            />
          </Route>
          {userGroup === "admin" && (
            <Route path="/usuarios">
              <UsersPage
                breadcrumbs={[
                  {
                    label: "Empresa",
                    path: "/",
                  },
                  {
                    label: "Usuários",
                    path: "/usuarios",
                  },
                ]}
              />
            </Route>
          )}
          <Route path="/relatorios/caixa-de-entrada">
            <InboxPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Relatórios",
                  path: "",
                },
                {
                  label: "Caixa de Entrada",
                  path: "",
                },
              ]}
            />
          </Route>
          <Route path="/relatorios/caixa-de-saida">
            <OutboxPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Relatórios",
                  path: "",
                },
                {
                  label: "Caixa de Saída",
                  path: "",
                },
              ]}
            />
          </Route>
          <Route path="/relatorios/mensagens-enviadas">
            <MessageSentPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Relatórios",
                  path: "",
                },
                {
                  label: "Mensagens Enviadas",
                  path: "",
                },
              ]}
            />
          </Route>
          <Route path="/relatorios/mensagens-recebidas">
            <ReceivedMessagePage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Relatórios",
                  path: "",
                },
                {
                  label: "Mensagens Recebidas",
                  path: "",
                },
              ]}
            />
          </Route>
          <Route path="/relatorios/sms-mo-dr">
            <SmsMoDrPage
              breadcrumbs={[
                {
                  label: "Início",
                  path: "/",
                },
                {
                  label: "Relatórios",
                  path: "",
                },
                {
                  label: "SMS - MO e DR",
                  path: "",
                },
              ]}
            />
          </Route>
          <Route>
            <Redirect to="/" />
          </Route>
        </Switch>
      </div>
    </div>
  );
}

export default Admin;
